<template>
    <IconSelect
        :value="value"
        :options="shapes"
        :src="(shape) => require(`~/assets/images/icons/${shape.icon}`)"
        :placeholder="$t('editor.shape.placeholder')"
        small
        :append-to="appendTo"
        v-on="$listeners"
    />
</template>

<script>
import IconSelect from '@/components/Editor/Shared/IconSelect.vue';
import { SHAPES } from '@/components/Editor/Shared/shapes';

export default {
    name: 'ShapeSelect',
    components: { IconSelect },
    props: {
        value: {
            type: Number,
            default: null,
        },
        appendTo: {
            type: [String, Object],
            default: null,
        },
    },
    data() {
        return { shapes: SHAPES };
    },
};
</script>
